import React from 'react';

import WindowDataObject from '@app/document/utils/WindowDataObject';

const globalBodyScripts = ({ req }) => {
  const { localization = {}, appContext = {} } = req || {};

  const { appConfig } = appContext;

  return (
    <>
      <WindowDataObject
        identifier="preLoadedLang"
        payload={localization?.preLoadedLang}
      />
      <WindowDataObject
        identifier="initialRecoilState"
        payload={appConfig?.initialRecoilState}
      />
      <WindowDataObject
        identifier={appContext?.states?.page_config?.windowKey}
        payload={appContext?.states?.page_config?.value}
      />
    </>
  );
};

export default globalBodyScripts;
